const mixin = {
  mounted: function() {
    this.loadFaqs()
  },
  methods: {
    loadFaqs() {
      const gqlDoc = `
      query faqs {
        winefaqlist {
          id
          type
          access
          status
          created
          featured
          title
          body
          category
        }
      }
    `

      return this.$store.getters['getGraphQLClient'](null, gqlDoc).query({opName: 'faqs'})
        .then(response => {
          if (response && response.data && response.data.winefaqlist) {
            // faq_categories is deferred from the SSR-inlined state (see
            // applyFieldMapper.js) and lazy-fetched independently of this
            // FAQ load, which runs unconditionally on mount - guard against
            // the race where this resolves first and faq_categories isn't
            // there yet.
            this.faqlist = Object.values(response.data.winefaqlist)
              .filter(faq => (faq.type === 'wine_product_faq' && (this.item.faq_categories || []).includes(faq.category)))
              .reduce((acc, item) => ({ ...acc, [item.id]: { ...item, category: item.category.replace('_', '') } }), {})
          }
        })
    }
  },
  watch: {
    '$route.fullPath': {
      handler: function(updated, old) {
        this.loadFaqs()
      }
    }
  }
}

export default mixin
